import React from 'react';
import './pagefooter.css';
import { Helmet } from "react-helmet-async";

const Privacy = () => (
  <>
  <Helmet>
    <title>
      Privacy Policy | AIKYAM Sports Science
    </title>

    <meta
      name="description"
      content="Read the AIKYAM Sports Science Privacy Policy to understand how we collect, use, store and protect your personal information, athlete performance data, and account information."
    />

    <meta
      name="keywords"
      content="AIKYAM Privacy Policy, Sports Science Privacy, Athlete Data Privacy, Privacy Policy India, Sports App Privacy, Data Protection"
    />

    <link
      rel="canonical"
      href="https://aikyamsports.com/privacy"
    />

    {/* Open Graph */}
    <meta
      property="og:title"
      content="Privacy Policy | AIKYAM Sports Science"
    />

    <meta
      property="og:description"
      content="Learn how AIKYAM Sports Science collects, protects and manages your personal information and athlete performance data."
    />

    <meta
      property="og:url"
      content="https://aikyamsports.com/privacy"
    />

    <meta
      property="og:type"
      content="website"
    />

    <meta
      property="og:image"
      content="https://aikyamsports.com/logo11.png"
    />

    {/* Twitter */}
    <meta
      name="twitter:card"
      content="summary_large_image"
    />

    <meta
      name="twitter:title"
      content="Privacy Policy | AIKYAM Sports Science"
    />

    <meta
      name="twitter:description"
      content="Read the AIKYAM Sports Science Privacy Policy regarding personal information, athlete performance data and user privacy."
    />

    <meta
      name="twitter:image"
      content="https://aikyamsports.com/logo11.png"
    />
  </Helmet>
  <div className="policy-page">
    <h1>Privacy Policy</h1>
    <p>Aikyam Sports Science is committed to protecting your privacy. This policy explains how we collect, use, and safeguard your information.</p>
    <ul>
      <li><strong>Information Collection:</strong> We collect personal information such as name, contact details, and performance data when you use our services or products.</li>
      <li><strong>Use of Information:</strong> Your data is used to provide and improve our services, process orders, and communicate with you.</li>
      <li><strong>Data Security:</strong> We implement industry-standard security measures to protect your information.</li>
      <li><strong>Sharing:</strong> We do not sell or share your personal information with third parties except as required by law or to provide our services.</li>
      <li><strong>Contact:</strong> For privacy-related questions, contact us at +916363202281 or +917019386664.</li>
    </ul>
    <p>Location: Center for Sports Science, Mahatma Gandhi Stadium, Ajjarakad, Brahmagiri, Udupi, Karnataka - 576101</p>
  </div>
  </>
);

export default Privacy;
